<template>
  <div>
    <div class="pl-0 ml-0 mt-10">
      <p class="mb-0 title font-weight-bold mr-5">
        발송 타입 설정
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        {{ isAllowedKakao ? "카톡+" : "" }}SMS+메일 발송 연동은 원하는 발송 타입을 선택하여 발송할 수 있습니다. <br />
        <font v-if="appCode !== 'cert_digital'">
          발송 타입과 상관없이 연동 포인트(22p) 차감은 동일하며, SMS의 경우 쇼핑몰 발신번호를 그대로 사용할 수 있도록 카페24 관리자와
          연동하여 발송합니다.
          <br />
          고객이 카카오톡을 사용하지 않거나, 알림톡 차단 설정을 하여 카카오톡 발송이 실패되는 경우 SMS로 발송처리가 가능합니다.<br />
        </font>
        <font v-if="appCode === 'cert_digital'">
          SMS의 경우 쇼핑몰 발신번호를 그대로 사용할 수 있도록 카페24 관리자와 연동하여 발송합니다.
        </font>
      </p>
      <v-btn color="grey darken-4" class="white--text mt-2" @click.prevent="openSendTypeModal(true)">
        발송 타입 설정하기
      </v-btn>
    </div>
    <div class="pl-0 ml-0 mt-12" v-if="appCode !== 'cert_digital'">
      <p class="mb-0 title font-weight-bold mr-5">
        카카오톡 채널 설정
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium">
        카카오 알림톡 발송을 위해서 채널 세팅이 필요합니다.<br />
        카카오 채널을 추가한 후 아래 발송 조건별 사용 및 메시지를 설정해주세요.<br />
        설정한 메시지는 카카오톡 검수가 완료되면 연동 및 발송 처리가 가능합니다.<br />
        등록한 카카오톡 메시지 검수 완료까지 3~5일 정도 소요될 수 있어 참고해주세요.
      </p>
      <v-btn v-if="!kakao_channel_status" color="yellow" class="mt-3" @click.prevent="openAddKakaoChannelModal">
        <img src="@/assets/authservice/images/kakao-icon.png" alt="kakao_icon" class="mr-2 btn_icon" />
        카카오톡 채널 추가하기</v-btn
      >
      <p v-else class="mt-3 blue--text">
        <span class="font-weight-bold">[ {{ kakao_channel_id }} ]</span> 채널 추가가 완료되었습니다.
      </p>
    </div>
    <div class="pl-0 ml-0 mt-12">
      <p class="mb-0 title font-weight-bold mr-5">
        발송 조건별 사용 및 메시지 설정
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium" v-if="appCode !== 'cert_digital'">
        주문 상태 및 인증 상태별 메시지 설정 및 카톡/SMS/메일 발송이 가능합니다.<br />
        인증 상태별 발송을 사용하시려면, <strong>[정품 인증 설정] 메뉴의 ‘쇼핑몰 정품 인증 화면 - 고객 정보 입력 설정’을 사용</strong>하셔야
        발송이 가능합니다.
      </p>
      <p class="mb-0 mt-2 subtitle-2 font-weight-medium" v-else>
        발송 조건별 사용 여부와 발송 메시지 설정이 가능합니다.<br />
        카페24 쇼핑몰에서 주문한 고객에게 발송되며, 배송완료/구매확정/반품접수/반품완료 상태일때 발송할 수 있습니다.
      </p>
    </div>
    <div class="mt-5">
      <p class="mt-10 mb-0 font-weight-bold" v-if="appCode !== 'cert_digital'">
        주문 상태별 발송
        <v-btn color="grey darken-4" small class="white--text ml-3" @click.prevent="openSendOrderProductModal">주문 상품 설정하기</v-btn>
        <v-btn color="teal" small class="white--text ml-2" @click.prevent="openExternalChannelSendModal"
          >다른 판매 채널 주문건 엑셀 발송</v-btn
        >
      </p>
      <div class="message-list">
        <div v-for="(config, index) in filteredOrderMessageConfig" :key="index" class="card-items pl-0 ml-0 pb-1">
          <v-card outlined width="300" rounded="xl" class="message-card d-flex flex-column">
            <v-card-title class="text-subtitle-2 mb-2">{{ config.title }}</v-card-title>
            <v-card-subtitle v-html="getDescription(config)" class="pb-0"></v-card-subtitle>
            <v-card-actions class="justify-space-between mx-3 mt-auto mb-2">
              <v-switch
                @change="changeMessageStatus('order', config.msg_type, config.title)"
                v-model="config.status"
                hide-details="false"
                inset
                class="mt-0 pt-0"
              ></v-switch>
              <v-btn small outlined text @click="settingMessage(config)">발송 메세지 설정</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <div class="mt-5" v-if="appCode !== 'cert_digital'">
      <p class="mt-10 mb-0 font-weight-bold">
        인증 상태별 발송
      </p>
      <div class="message-list">
        <div v-for="(config, index) in cert_message_config" :key="index" class="card-items pl-0 ml-0 pb-1">
          <v-card outlined width="300" rounded="xl" class="message-card d-flex flex-column">
            <v-card-title class="text-subtitle-2 mb-2" v-html="config.title"></v-card-title>
            <v-card-subtitle v-html="config.description" class="pb-0"></v-card-subtitle>
            <v-card-actions class="justify-space-between mx-3 mt-auto mb-2">
              <v-switch
                @change="changeMessageStatus('certification', config.msg_type, config.title)"
                v-model="config.status"
                hide-details="false"
                inset
                class="mt-0 pt-0"
              ></v-switch>
              <v-btn v-if="config.msg_type.includes('expired')" @click="openDaySettingModal(config.msg_type)" small outlined text
                >발송일 설정</v-btn
              >
              <v-btn small outlined text @click="settingMessage(config)">발송 메세지 설정</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <div class="mt-5" v-if="is_aftercare_custom">
      <p class="mt-10 mb-0 font-weight-bold">애프터케어 상태별 발송</p>
      <div class="message-list">
        <div v-for="(config, index) in aftercare_message_config" :key="'aftercare_' + index" class="card-items pl-0 ml-0 pb-1">
          <v-card outlined width="300" rounded="xl" class="message-card d-flex flex-column">
            <v-card-title class="text-subtitle-2 mb-2" v-html="config.title"></v-card-title>
            <v-card-subtitle v-html="config.description" class="pb-0"></v-card-subtitle>
            <v-card-actions class="justify-space-between mx-3 mt-auto mb-2">
              <v-switch
                @change="changeMessageStatus('as', config.msg_type, config.title)"
                v-model="config.status"
                hide-details="false"
                inset
                class="mt-0 pt-0"
              ></v-switch>
              <v-btn small outlined text @click="settingMessage(config)">발송 메세지 설정</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <div class="mt-5" v-if="is_as_custom && !is_aftercare_custom">
      <p class="mt-10 mb-0 font-weight-bold">A/S 상태별 발송</p>
      <div class="message-list">
        <div v-for="(config, index) in as_message_config" :key="index" class="card-items pl-0 ml-0 pb-1">
          <v-card outlined width="300" rounded="xl" class="message-card d-flex flex-column">
            <v-card-title class="text-subtitle-2 mb-2" v-html="config.title"></v-card-title>
            <v-card-subtitle v-html="config.description" class="pb-0"></v-card-subtitle>
            <v-card-actions class="justify-space-between mx-3 mt-auto mb-2">
              <v-switch
                @change="changeMessageStatus('as', config.msg_type, config.title)"
                v-model="config.status"
                hide-details="false"
                inset
                class="mt-0 pt-0"
              ></v-switch>
              <v-btn small outlined text @click="settingMessage(config)">발송 메세지 설정</v-btn>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <div class="mt-5" v-if="is_as_custom || is_aftercare_custom">
      <p class="mt-10 mb-0 font-weight-bold">정품 인증 회원 관리 메뉴 - 수동 발송</p>
      <div class="message-list">
        <div v-for="(config, index) in manual_message_config" :key="index" class="card-items pl-0 ml-0 pb-1">
          <v-card outlined width="300" rounded="xl" class="message-card d-flex flex-column">
            <v-card-title class="text-subtitle-2 mb-2 d-flex align-center">
              <v-text-field v-if="config.is_editing" v-model="config.edit_title" dense hide-details outlined class="mr-2"></v-text-field>
              <span v-else>{{ config.title }}</span>
              <v-btn v-if="config.is_editing" small class="ml-auto" @click="saveManualTitle(config)">저장</v-btn>
            </v-card-title>
            <v-card-subtitle class="pb-0" v-html="config.description"></v-card-subtitle>
            <v-card-actions class="justify-space-between mx-3 mt-auto mb-2">
              <v-switch
                @change="changeMessageStatus('manual', config.msg_type, config.title)"
                v-model="config.status"
                hide-details="false"
                inset
                class="mt-0 pt-0"
              ></v-switch>
              <div class="d-flex">
                <v-btn v-if="!config.is_editing" small outlined text class="mr-2" @click="startManualTitleEdit(config)">타이틀 변경</v-btn>
                <v-btn small outlined text @click="settingMessage(config)">발송 메세지 설정</v-btn>
              </div>
            </v-card-actions>
          </v-card>
        </div>
      </div>
    </div>
    <SendTypeSetting ref="SendTypeSetting" @save="setSendType"></SendTypeSetting>
    <MessageDaySetting ref="MessageDaySetting"></MessageDaySetting>
    <AddKakaoChannel ref="AddKakaoChannel" @get-kakao="getKakaoChannelStatus"></AddKakaoChannel>
    <SendOrderProductSetting ref="SendOrderProductSetting"></SendOrderProductSetting>
    <MessageDetailSetting ref="MessageDetailSetting"></MessageDetailSetting>
    <ExternalChannelSendModal ref="ExternalChannelSendModal"></ExternalChannelSendModal>
  </div>
</template>
<style>
.card-items {
  min-width: 300px;
}

.message-list {
  min-width: 720px;
  flex-wrap: wrap;
  gap: 10px;
  display: flex;
  margin-top: 8px;
}

.message-card {
  background-color: #f9f9f9 !important;
  min-height: 180px;
}

.message-card .v-card__title {
  font-size: 16px;
  line-height: normal;
  font-weight: bold;
}

.message-card .v-card__subtitle {
  font-size: 13px;
  line-height: normal;
  font-weight: normal;
}

.message-card button {
  background-color: white;
}

.btn_icon {
  width: 32px;
  height: 32px;
}
.v-card__actions .v-btn.v-btn {
  padding: 0 8px;
}
</style>

<script>
import M from "@/libs/mapping.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import SendTypeSetting from "@/components/authservice/message/modal/SendTypeSetting.vue";
import MessageDaySetting from "@/components/authservice/message/modal/MessageDaySetting.vue";
import AddKakaoChannel from "@/components/authservice/message/modal/AddKakaoChannel.vue";
import SendOrderProductSetting from "@/components/authservice/message/modal/SendOrderProductSetting.vue";
import MessageDetailSetting from "@/components/authservice/message/modal/MessageDetailSetting.vue";
import ExternalChannelSendModal from "@/components/authservice/message/modal/ExternalChannelSendModal.vue";

export default {
  mixins: [CommonMixin],
  props: {
    sendingType: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    my_send_type: "",
    kakao_channel_status: false,
    kakao_channel_id: "",
    auto_change_type: "",
    is_as_custom: false,
    is_aftercare_custom: false,
    aftercare_message_config: [
      {
        msg_type: "receipt_start",
        status: false,
        title: "쇼핑몰에서 고객이 애프터케어 신청하면 발송",
        description: "쇼핑몰에서 고객이 애프터케어를 신청하면 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "receipt_done",
        status: false,
        title: "앱에서 관리자가 접수 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 접수 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "center_in",
        status: false,
        title: "앱에서 관리자가 센터 입고 상태로 변경시 발송",
        description: "앱에서 관리자가 센터 입고 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "payment_waiting",
        status: false,
        title: "앱에서 관리자가 입금 대기 중 상태로 변경시 발송",
        description: "앱에서 관리자가 입금 대기 중 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "payment_done",
        status: false,
        title: "앱에서 관리자가 입금 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 입금 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "as_done",
        status: false,
        title: "앱에서 관리자가 애프터케어 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 애프터케어 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "shipping_done",
        status: false,
        title: "앱에서 관리자가 출고 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 출고 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "done",
        status: false,
        title: "앱에서 관리자가 처리 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 처리 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
    ],
    order_message_config: [
      {
        msg_type: "payment_end",
        status: false,
        title: "결제완료 상태가 되면 발송",
        description: {
          default: "고객이 쇼핑몰에서 정품을 구매하고 <br/>결제가 완료되면 메시지+메일을 발송합니다.",
          cert_digital: "",
        },
      },
      {
        msg_type: "shipping_start",
        status: false,
        title: "배송중 상태가 되면 발송",
        description: {
          default: "구매한 정품이 배송 시작이 되면 <br/>고객에게 메시지+메일을 발송합니다.",
          cert_digital: "",
        },
      },
      {
        msg_type: "shipping_end",
        status: false,
        title: "배송완료 상태가 되면 발송",
        description: {
          default:
            "구매한 정품이 배송완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>정품코드를 배송시 동봉하지 않는 경우<br/>미인증된 시리얼코드를 전송할 수 있어요.",
          cert_digital:
            "구매한 상품이 배송완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>미인증된 시리얼코드를 전송할 수 있어요.",
        },
      },
      {
        msg_type: "buyed_confirm",
        status: false,
        title: "구매확정 상태가 되면 발송",
        description: {
          default:
            "구매한 정품이 구매확정 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>정품코드를 배송시 동봉하지 않는 경우<br/>미인증된 시리얼코드를 전송할 수 있어요.",
          cert_digital:
            "구매한 상품이 구매확정 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>미인증된 시리얼코드를 전송할 수 있어요.",
        },
      },
      {
        msg_type: "cancel_start",
        status: false,
        title: "취소접수 상태가 되면 발송",
        description: {
          default:
            "구매한 정품이 취소접수 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>정품 인증 혜택을 안내함으로써 취소를 <br/>줄일 수 있어요.",
          cert_digital: "",
        },
      },
      {
        msg_type: "cancel_end",
        status: false,
        title: "취소완료 상태가 되면 발송",
        description: {
          default: "구매한 정품이 취소완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.",
          cert_digital: "",
        },
      },
      {
        msg_type: "exchange_start",
        status: false,
        title: "교환접수 상태가 되면 발송",
        description: {
          default: "구매한 정품이 교환접수 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.",
          cert_digital: "",
        },
      },
      {
        msg_type: "exchange_end",
        status: false,
        title: "교환완료 상태가 되면 발송",
        description: {
          default: "구매한 정품이 교환완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.",
          cert_digital: "",
        },
      },
      {
        msg_type: "refund_start",
        status: false,
        title: "반품접수 상태가 되면 발송",
        description: {
          default:
            "구매한 정품이 반품접수 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>정품 인증 혜택을 안내함으로써 반품을 <br/>줄일 수 있어요.",
          cert_digital:
            "구매한 상품이 반품접수 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>디지털 상품의 반품 관련 안내를 별도 발송할 수 있어요.",
        },
      },
      {
        msg_type: "refund_end",
        status: false,
        title: "반품완료 상태가 되면 발송",
        description: {
          default: "구매한 정품이 반품완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.",
          cert_digital:
            "구매한 상품이 반품완료 상태로 변경되면<br/>고객에게 메시지+메일을 발송합니다.<br/>디지털 상품의 반품 관련 안내를 별도 발송할 수 있어요.",
        },
      },
    ],
    cert_message_config: [
      {
        msg_type: "member_cert_end",
        status: false,
        title: "쇼핑몰에서 고객이<br/>인증 완료하면 발송",
        description: "쇼핑몰에서 고객이 인증 완료시 <br/>보증기간 및 혜택 안내를 할 수 있어요.",
      },
      {
        msg_type: "admin_cert_end",
        status: false,
        title: "앱에서 관리자가 <br/>인증 완료하면 발송",
        description: "엡에서 관리자가 인증 완료시 <br/>보증기간 및 혜택 안내를 할 수 있어요.",
      },
      {
        msg_type: "admin_approval_end",
        status: false,
        title: "앱에서 관리자가 <br/>승인 완료하면 발송",
        description: "승인 상태 설정을 사용하는 경우 <br/>관리자가 인증 완료 -> 승인 완료시 <br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "expired_before",
        status: false,
        title: "정품 보증 기간<br/>만료 전 발송",
        description: "정품 보증 기간 만료 안내 메시지를<br/>전달할 수 있어요. <br/>신제품 및 보증 기간 연장등 안내해보세요.",
      },
      {
        msg_type: "expired_after",
        status: false,
        title: "정품 보증 기간<br/>만료 후 발송",
        description: "정품 보증 기간 만료 안내 메시지를<br/>전달할 수 있어요. <br/>신제품 및 보증 기간 연장등 안내해보세요.",
      },
      {
        msg_type: "member_cert_cancel",
        status: false,
        title: "쇼핑몰에서 고객이 <br/>인증 취소하면 발송",
        description: "쇼핑몰에서 고객이 인증 취소를 하는 경우<br/>(미인증 상태로 변경)<br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "admin_cert_cancel",
        status: false,
        title: "앱에서 관리자가 <br/>인증 취소하면 발송",
        description: "엡에서 관리자가 인증 취소시 <br/>(미인증 상태로 변경)<br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "member_lost_regist",
        status: false,
        title: "쇼핑몰에서 고객이 <br/>분실 변경하면 발송",
        description: "분실 버튼 노출 설정을 사용하는 경우 <br/>쇼핑몰에서 고객이 분실로 변경시<br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "admin_lost_regist",
        status: false,
        title: "앱에서 관리자가 <br/>분실 변경하면 발송",
        description: "분실 버튼 노출 설정을 사용하는 경우 <br/>엡에서 관리자가 분실로 변경시<br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "member_lost_cancel",
        status: false,
        title: "쇼핑몰에서 고객이 <br/>분실 취소하면 발송",
        description: "쇼핑몰에서 고객이 인증 취소를 하는 경우<br/>고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "lost_3rd_verify_member",
        status: false,
        title: "분실 상품을 제3자가 인증 시도시<br/>분실 신청한 고객에게 발송",
        description: "쇼핑몰에서 분실상품을 제3자가 인증 시도시 <br/>분실 신청한 고객에게 메시지+메일을 <br/>발송합니다.",
      },
      {
        msg_type: "lost_3rd_verify_admin",
        status: false,
        title: "분실 상품을 제3자가 인증 시도시<br/>관리자에게 발송",
        description: "쇼핑몰에서 분실상품을 제3자가 인증 시도시 <br/>관리자에게 메시지+메일을 발송합니다.",
      },
    ],
    as_message_config: [
      {
        msg_type: "receipt_start",
        status: false,
        title: "쇼핑몰에서 고객이 A/S 신청하면 발송",
        description: "쇼핑몰에서 고객이 A/S 신청하면 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "receipt_done",
        status: false,
        title: "앱에서 관리자가 접수 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 접수 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "center_in",
        status: false,
        title: "앱에서 관리자가 센터 입고 상태로 변경시 발송",
        description: "앱에서 관리자가 센터 입고 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "payment_waiting",
        status: false,
        title: "앱에서 관리자가 입금 대기 중 상태로 변경시 발송",
        description: "앱에서 관리자가 입금 대기 중 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "payment_done",
        status: false,
        title: "앱에서 관리자가 입금 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 입금 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "as_done",
        status: false,
        title: "앱에서 관리자가 A/S 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 A/S 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "shipping_done",
        status: false,
        title: "앱에서 관리자가 출고 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 출고 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
      {
        msg_type: "done",
        status: false,
        title: "앱에서 관리자가 처리 완료 상태로 변경시 발송",
        description: "앱에서 관리자가 처리 완료 상태로 변경시 고객에게 메시지+메일을 발송합니다.",
      },
    ],
    manual_message_config: [
      {
        msg_type: "template_1",
        status: false,
        title: "템플릿 1",
        edit_title: "",
        is_editing: false,
        description: "정품 인증 회원 관리 메뉴에서<br/>설정한 템플릿을 별도 발송할 수 있습니다.",
      },
      {
        msg_type: "template_2",
        status: false,
        title: "템플릿 2",
        edit_title: "",
        is_editing: false,
        description: "정품 인증 회원 관리 메뉴에서<br/>설정한 템플릿을 별도 발송할 수 있습니다.",
      },
      {
        msg_type: "template_3",
        status: false,
        title: "템플릿 3",
        edit_title: "",
        is_editing: false,
        description: "정품 인증 회원 관리 메뉴에서<br/>설정한 템플릿을 별도 발송할 수 있습니다.",
      },
      {
        msg_type: "template_4",
        status: false,
        title: "템플릿 4",
        edit_title: "",
        is_editing: false,
        description: "정품 인증 회원 관리 메뉴에서<br/>설정한 템플릿을 별도 발송할 수 있습니다.",
      },
      {
        msg_type: "template_5",
        status: false,
        title: "템플릿 5",
        edit_title: "",
        is_editing: false,
        description: "정품 인증 회원 관리 메뉴에서<br/>설정한 템플릿을 별도 발송할 수 있습니다.",
      },
    ],
    digital_allowed_types: ["shipping_end", "buyed_confirm", "refund_start", "refund_end"],
  }),
  methods: {
    setSendType: function(type) {
      this.my_send_type = type;
      this.$emit("update", type);
    },
    settingMessage: function(info) {
      // appCode에 맞는 description으로 info 객체를 복사하여 전달
      const modifiedInfo = {
        ...info,
        description:
          info.description && typeof info.description === "object"
            ? info.description[this.appCode] || info.description.default
            : info.description,
      };
      this.$refs.MessageDetailSetting.openMessageDetailSettingModal(modifiedInfo);
    },
    openSendOrderProductModal() {
      this.$refs.SendOrderProductSetting.openSendOrderProductModal(true);
    },
    openExternalChannelSendModal() {
      this.$refs.ExternalChannelSendModal.open();
    },
    openAddKakaoChannelModal() {
      this.$refs.AddKakaoChannel.openAddKakaoChannelModal();
    },
    openSendTypeModal(set_open) {
      const data = {
        open: set_open,
        sendType: this.my_send_type,
      };
      this.$refs.SendTypeSetting.openSendTypeModal(data);
    },
    openDaySettingModal(msg_type) {
      this.$refs.MessageDaySetting.openDaySettingModal(msg_type);
    },
    startManualTitleEdit(config) {
      config.edit_title = config.title;
      config.is_editing = true;
    },
    saveManualTitle(config) {
      const nextTitle = (config.edit_title || "").trim();
      if (nextTitle) {
        this.updateManualTitle(config, nextTitle);
      }
    },
    updateManualTitle: async function(config, nextTitle) {
      try {
        const res = await M.api(M.entry("/put/message/title"), {
          type: "manual",
          msg_type: config.msg_type,
          msg_title: nextTitle,
        });
        if (res) {
          config.title = nextTitle;
          config.is_editing = false;
          this.alertShow("저장되었습니다.");
        }
      } catch (err) {
        console.log("update manual title error", err);
      }
    },
    getKakaoChannelStatus: async function() {
      try {
        const res = await M.api(M.entry("/get/config/kakao"));
        if (res.status === "enabled") {
          this.kakao_channel_status = res.status === "enabled";
          this.kakao_channel_id = res.id;
        }
      } catch (err) {
        console.log("get Kakao info error", err);
      }
    },
    getMessageStatusList: async function(type) {
      try {
        const res = await M.api(M.entry("/get/config/message"), { type: type });
        if (res) {
          res.forEach((item) => {
            if (item.type === "order") {
              const config = this.order_message_config.find((msg_item) => msg_item.msg_type === item.msg_type);
              if (config) {
                config.status = item.status === "enabled";
              }
            } else if (item.type === "as") {
              const config = this.as_message_config.find((msg_item) => msg_item.msg_type === item.msg_type);
              if (config) {
                config.status = item.status === "enabled";
              }
              const aftercareConfig = this.aftercare_message_config.find((msg_item) => msg_item.msg_type === item.msg_type);
              if (aftercareConfig) {
                aftercareConfig.status = item.status === "enabled";
              }
            } else if (item.type === "manual") {
              const config = this.manual_message_config.find((msg_item) => msg_item.msg_type === item.msg_type);
              if (config) {
                config.status = item.status === "enabled";
                if (item.msg_title) {
                  config.title = item.msg_title;
                }
              }
            } else {
              const config = this.cert_message_config.find((msg_item) => msg_item.msg_type === item.msg_type);
              if (config) {
                config.status = item.status === "enabled";
              }
            }
          });
        }
      } catch (err) {
        console.log("msg status error", err);
      }
    },
    changeMessageStatus: async function(type, msg_type, msg_title) {
      //console.log("change status before", msg_type, type, msg_title);
      let config = null;
      if (type === "order") {
        config = this.order_message_config.find((item) => item.msg_type === msg_type);
      } else if (type === "as") {
        config = this.as_message_config.find((item) => item.msg_type === msg_type);
        if (!config) {
          config = this.aftercare_message_config.find((item) => item.msg_type === msg_type);
        }
      } else if (type === "manual") {
        config = this.manual_message_config.find((item) => item.msg_type === msg_type);
      } else {
        config = this.cert_message_config.find((item) => item.msg_type === msg_type);
      }
      //console.log("change status", type, msg_type, config.status);
      try {
        // api call
        const res = await M.api(M.entry("/put/config/message"), {
          type: type,
          msg_type: msg_type,
          status: config.status ? "enabled" : "disabled",
          // status: config.status ? "disabled" : "enabled",
        });
        if (res.status === "enabled") {
          config.status = true; // Toggle status
          this.alertShow(
            `'${msg_title}' \n사용함으로 변경되었습니다.\n발송 타입 메시지 설정등 관련 설정이 완료되어야\n실제 발송이 되오니 설정 내역을 체크하시길 권장합니다.`,
            4000
          );
          //this.alertShow(`발송 타입 메시지 설정등 관련 설정이 완료되어야\n실제 발송처리가 되오니 설정 내역을 체크하시길 권장합니다.`);
        } else if (res.status === "disabled") {
          config.status = false;
          this.alertShow(`'${msg_title}' \n사용안함으로 변경되었습니다.`);
        }
      } catch (err) {
        config.status = !config.status; // Revert status on error
        console.log("changeMessageStatus error", err);
      }
      return false;
    },
    getDigitalConfig: async function() {
      try {
        let data = await M.api(M.entry("/get/digital/config"));
        if (data) {
          this.auto_change_type = data.auto_change_type;
        }
      } catch (e) {
        //console.log(e);
      }
    },
  },
  computed: {
    isAllowedKakao() {
      return this.isAllowedKakaoForDigital();
    },
    appCode() {
      // store에서 appCode 값을 가져옴 (없으면 cert_product가 기본값)
      return this.$store.state.appCode || "cert_product";
    },
    filteredOrderMessageConfig() {
      if (this.appCode === "cert_digital") {
        // For digital app code, only include these specific message types
        // 2026-07-24: auto_change_type 에 따른 shipping_end/buyed_confirm 필터 제거.
        // 어드민이 배송상태 자동 변경 설정과 무관하게 배송완료/구매확정 카드 모두 노출되어야 함.
        return this.order_message_config.filter((config) => this.digital_allowed_types.includes(config.msg_type));
      }
      // For other app codes, show all message types
      return this.order_message_config;
    },
    getDescription() {
      return (config) => {
        return config.description[this.appCode] || config.description.default;
      };
    },
  },
  watch: {
    sendingType: function(newVal) {
      this.my_send_type = newVal;
    },
  },
  created: async function() {
    // init data
    await this.waitForShopNo();
    this.is_as_custom = M.isCustomCheck() === "as_custom";
    this.is_aftercare_custom = M.isAftercareCheck();
    this.my_send_type = this.sendingType;
    this.getKakaoChannelStatus();
    if (this.appCode === "cert_digital") {
      this.getDigitalConfig();
    }
    this.getMessageStatusList("order");
    if (this.appCode !== "cert_digital") {
      this.getMessageStatusList("certification");
    }
    if (this.is_as_custom || this.is_aftercare_custom) {
      this.getMessageStatusList("as");
      this.getMessageStatusList("manual");
    }
  },
  components: {
    SendTypeSetting,
    MessageDaySetting,
    AddKakaoChannel,
    SendOrderProductSetting,
    MessageDetailSetting,
    ExternalChannelSendModal,
  },
};
</script>
